import {
  Stack,
  Typography,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";
import MainCard from "@pd/components/MainCard";
import { OrderDetailDbType } from "@pd/redux/types/dbTypes";
import formatCurrency from "@pd/utils/formatCurrency";

type Props = {
  order: OrderDetailDbType | null;
};
export default function AdvancesSection(props: Props) {
  const theme = useTheme();

  if (!props.order) {
    return null;
  }

  if (
    [
      !props.order?.isFinanced,
      props.order?.isFinanced && !props.order?.payoutAmount,
    ].some(Boolean)
  ) {
    return null;
  }

  return (
    <Stack sx={{ flexGrow: 1 }}>
      <MainCard
        title="Advance"
        darkTitle
        sx={{
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
      >
        <Stack>
          <Stack direction="row" justifyContent="space-between" sx={{ pb: 1 }}>
            <Typography>Financing Fees</Typography>
            <Typography>{formatCurrency(props.order.fees)}</Typography>
          </Stack>
          <Divider />
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ pt: 1, mb: 2 }}
          >
            <Typography variant="h5" sx={{ pt: 1 }}>
              Pay out
            </Typography>
            <Typography variant="h5" sx={{ pt: 1 }}>
              {formatCurrency(props.order.payoutAmount)}
            </Typography>
          </Stack>
        </Stack>
      </MainCard>
      <CardHeader
        sx={{
          py: 4,
          fontFamily: "CircularBold",
          border: `1px solid ${theme.palette.grey.A800}`,
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
          borderTop: "none",
        }}
        titleTypographyProps={{ variant: "subtitle1" }}
        title={
          <Stack direction="row" justifyContent="space-between">
            <Typography sx={{ fontFamily: "CircularBold" }}>
              Debit Total
            </Typography>
            <Typography variant="h5">
              {formatCurrency(props.order.debitTotal)}
            </Typography>
          </Stack>
        }
      />
    </Stack>
  );
}
